// import logo from './logo.svg';

import { Routes, Route } from 'react-router-dom'
import './App.css';
import Home from './pages/Home';
import Contact from './pages/Contact';
import About from './pages/About';
import Privacypolicy from './pages/Privacypolicy';
import TermandCondition from './pages/TermandCondition';
import Product from './pages/Product';
function App() {

  return (
    <>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<About />} />
        <Route path='/contact' element={<Contact />}></Route>
        <Route path='/product' element={<Product />}></Route>
        <Route path='/privacy-policy' element={<Privacypolicy />}></Route>
        <Route path='/terms-and-conditions' element={<TermandCondition />}></Route>

      </Routes>


    </>

  );
}

export default App;